import { render, staticRenderFns } from "./PolipectomiaEndoscopicaIntestinoCrassoList.vue?vue&type=template&id=44de4495"
import script from "./PolipectomiaEndoscopicaIntestinoCrassoList.vue?vue&type=script&lang=js"
export * from "./PolipectomiaEndoscopicaIntestinoCrassoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports